<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card>
      <v-toolbar
        flat
        color="blue-grey"
        dark
      >
        <v-toolbar-title>Nhắn cho Người bán/Người mua</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-toolbar>

      <v-card-text class="mt-4">
        <div class="row" v-if="errors_exist">
          <div class="col">
            <v-alert
              dense
              outlined
              type="error"
            >
              Đã xảy ra lỗi! Vui lòng thử lại. 
              <ul>
                <div v-for="error in errors">
                  <li>{{ error[0] }}</li>
                </div>
              </ul>
            </v-alert>
          </div>
        </div>
        <v-text-field
          v-model="item.name"
          filled
          label="Tên liên hệ*"
        ></v-text-field>

        <v-text-field
          v-model="item.email"
          filled
          label="Email"
        ></v-text-field>

        <v-text-field
          v-model="item.phone"
          filled
          label="Số điện thoại*"
        ></v-text-field>

        <v-text-field
          v-model="item.title"
          filled
          label="Title"
        ></v-text-field>

        <v-textarea
          v-model="item.message"
          filled
          label="Message"
        ></v-textarea>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <small>*trường bắt buộc</small>
        <v-spacer></v-spacer>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          depressed
          @click="send"
        >
          Gửi đi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapGetters, mapState } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      sanPhamId: {
        type: String,
      },
    },
    data () {
      return {
        dialog: false,
        errors_exist: false,
        errors: [],
        item: {}
      }
    },
    computed: {
      ...mapGetters([
        'isLogged'
      ]),
      ...mapState([
        'user'
      ]),
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        if (this.showDialog) {
          this.dialog = true;

          if(this.isLogged){
            const user = this.user.user;
            this.item = {
              name: user.name,
              email: user.email,
              phone: user.info ? user.info.so_dien_thoai : '',
              user_id: user.id,
              loai_msg: 1,
              sanpham_id: this.sanPhamId
            };
          }
        }
      }
    },
    methods: {
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      send() {
        let app = this;
        axios.post('api/v1/public/cosos-message', this.item)
          .then((response) => {
            if (response.data && response.data.id) {
              this.$emit('confirmed', response.data);
            }
            this.dialog = !this.dialog;
          }).catch(function (error) {
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>